"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m16.79 5.8-1.94-1.94c-.31-.32-.09-.86.36-.86h5.29c.28 0 .5.22.5.5v5.29c0 .45-.54.67-.85.35L18.21 7.2l-4.09 4.09-1.41-1.41zM19 13v3.17l2 2V13c0-.55-.45-1-1-1s-1 .45-1 1m.07 8.9-.9-.9H5c-1.11 0-2-.9-2-2V5.83l-.9-.9a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0l16.97 16.97c.39.39.39 1.02 0 1.41s-1.02.39-1.41 0m-2.9-2.9-4.88-4.88-.88.88c-.39.39-1.02.39-1.41 0a.996.996 0 0 1 0-1.41l.88-.88L5 7.83V19zM7.83 5H11c.55 0 1-.45 1-1s-.45-1-1-1H5.83z"
}), 'OpenInNewOffRounded');